<!-- components/Analytics.vue -->
<template>
    <div style="display: none;">
      <div v-if="scriptsHtml" v-html="scriptsHtml"></div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Analytics',
    props: {
      scripts: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      scriptsHtml() {
        if (!this.scripts || !Array.isArray(this.scripts)) {
          return '';
        }
        return this.scripts.join('');
      }
    },
    mounted() {
      this.loadAnalytics();
    },
    methods: {
      loadAnalytics() {
        if (!this.scripts || this.scripts.length === 0 || typeof window === 'undefined') {
          return;
        }
        
        if (window._analyticsLoaded) return;
        
        // 方法1：直接使用innerHTML
        const container = document.createElement('div');
        container.style.display = 'none';
        container.innerHTML = this.scriptsHtml;
        document.body.appendChild(container);
        
        // 标记已加载
        window._analyticsLoaded = true;
      }
    }
  }
  </script>